<template>
  <v-container fill-height fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" md="6">
        <v-progress-linear
          v-show="$store.state.loading"
          indeterminate
          color="primary"
        >
        </v-progress-linear>
        <NewInscription v-show="!$store.state.loading" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import NewInscription from "@/components/panel/NewInscription";
export default {
  name: "NewInscriptionView",
  components: {
    NewInscription
  }
};
</script>
